var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iconTextButton"},[_c('Tooltip',{attrs:{"active":_vm.activeTooltip,"color":_vm.tooltipColor,"text":_vm.tooltipText,"placement":_vm.tooltipPlacement}},[_c('div',{staticClass:"iconTextButton__tooltipContainer",class:[
        !_vm.showText
          ? 'iconTextButton__tooltipContainer--withoutLabel'
          : 'iconTextButton__tooltipContainer--withLabel'
      ],on:{"click":_vm.onClick}},[(_vm.showText)?_c('div',{staticClass:"iconTextButton__label"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('Icon',{attrs:{"icon":_vm.icon,"color":_vm.Colors.White,"size":28}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }